import { Grid } from '@mui/material';

import { FormCard, RenderFormField } from '@/components';

export const NotesForm = () => {
  return (
    <FormCard>
      <Grid sm={12} item>
        <RenderFormField name="notes" type="text-area" label="Notes" />
      </Grid>
    </FormCard>
  );
};
